import { Routes } from '@angular/router';
import { authMatchGuard } from 'lib-auth';

export const rootRoutes: Routes = [
    {path: '', pathMatch: 'full', redirectTo: '/app/home/dashboard'},
    {
        path: 'auth',
        loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
    },
    {
        path: 'app',
        loadChildren: () => import('./modules/app/app.module').then(m => m.AppModule),
        canMatch: [authMatchGuard]
    },
    {
        path: 'unauthorized',
        loadChildren: () => import('./modules/unauthorized/unauthorized.module').then(m => m.UnauthorizedModule)
    },
    {path: '**', redirectTo: '/app'}
];
